import { httpService, HttpResponse } from '../core/http'
import { PaginatedResponseData, PaginatedRequest } from '../core/interfaces'
import { DetailPaginatedRequest } from '../core/interfaces/details-paginated-request'
import {
  Contract,
  Customer,
  CustomersFilter,
  Address,
  Opportunity,
  Accompaniment,
  Contact
} from '../entities'
import { CustomerToSave } from '../entities/customerToSave'

export const createCustomer = async (paylaod: CustomerToSave) => {
  await httpService.post('/customers', paylaod)
}

export const getAllCustomers = async (
  query: PaginatedRequest<CustomersFilter>
): Promise<PaginatedResponseData<Customer>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get('/customers', {
      params: {
        ...query
      }
    })

    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const getCustomerById = async (id: string): Promise<Customer> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(`/customers/${id}`)
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const createCustomerContacts = async (
  payload: any
): Promise<PaginatedResponseData<Contact>> => {
  try {
    const httpResponse: HttpResponse = await httpService.post(
      `/customers/${payload?.id}/contacts`,
      payload
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const getCustomerContacts = async (
  query: DetailPaginatedRequest
): Promise<PaginatedResponseData<Contact>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `/customers/${query?.id}/contacts`,
      { params: { ...query } }
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const updateCustomerContacts = async (
  payload: any
): Promise<PaginatedResponseData<Contact>> => {
  try {
    const httpResponse: HttpResponse = await httpService.put(
      `/customers/${payload?.id}/contacts`,
      payload
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const deleteCustomerContacts = async (
  payload: any
): Promise<PaginatedResponseData<Contact>> => {
  try {
    const httpResponse: HttpResponse = await httpService.delete(
      `/customers/${payload?.id}/contacts`,
      { data: payload }
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const getCustomerAddresses = async (
  query: DetailPaginatedRequest
): Promise<PaginatedResponseData<Address>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `/customers/${query?.id}/addresses`,
      { params: { ...query } }
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const createCustomerAddress = async (
  payload: any
): Promise<PaginatedResponseData<any>> => {
  try {
    const httpResponse: HttpResponse = await httpService.post(
      `/customers/${payload?.id}/addresses`,
      payload
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const updateCustomerAddress = async (
  payload: any
): Promise<PaginatedResponseData<any>> => {
  try {
    const httpResponse: HttpResponse = await httpService.put(
      `/customers/${payload?.id}/addresses`,
      payload
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const deleteCustomerAddress = async (
  payload: any
): Promise<PaginatedResponseData<any>> => {
  try {
    const httpResponse: HttpResponse = await httpService.delete(
      `/customers/${payload?.id}/addresses`,
      { data: payload }
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const getCustomerContracts = async (
  query: DetailPaginatedRequest
): Promise<PaginatedResponseData<Contract>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `/customers/${query?.id}/contracts`,
      { params: { ...query } }
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const getCustomerAccompaniments = async (
  query: DetailPaginatedRequest
): Promise<PaginatedResponseData<Accompaniment>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `/customers/${query?.id}/accompaniments`,
      { params: { ...query } }
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const getCustomerOpportunities = async (
  query: DetailPaginatedRequest
): Promise<PaginatedResponseData<Opportunity>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `/customers/${query?.id}/opportunities`,
      { params: { ...query } }
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const getCustomerFinancials = async (
  query: DetailPaginatedRequest
): Promise<PaginatedResponseData<any>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `/customers/${query?.id}/financials`,
      { params: { ...query } }
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const getCustomerLastProducts = async (
  query: DetailPaginatedRequest
): Promise<PaginatedResponseData<any>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `/customers/${query?.id}/last-products`,
      { params: { ...query } }
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}

export const getCustomerServiceOrders = async (
  query: DetailPaginatedRequest
): Promise<PaginatedResponseData<any>> => {
  const { page, limit, id } = query
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `/orders/service-orders`,
      { params: { page, limit, filters: { customerId: id } } }
    )
    return httpResponse.data
  } catch (error: any) {
    return error
  }
}
